import {pageInfo, collectionDetails, exportData, confirmPayable} from '../api';
import {goodsCategory, plant} from "../../../../../api";

const collectionLandDeductionState = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    collectionDetailsObj: null,
    exportObj: [],
    plantObj: null,
    goodsCategoryObj: null,
    collectionSubmitObj: null,
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []);
    },
    GOODS_CATEGORY(state, data) {
      state.goodsCategoryObj = data;
    },
    PLANT(state, data) {
      state.plantObj = data;
    },
    COLLECTION_DETAILS(state, data) {
      state.collectionDetailsObj = data;
    },

    EXPORT_DATA(state, data) {
      state.exportObj = data;
    },
    SUBMIT(state, data){
      state.collectionSubmitObj = data;
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async goodsCategory({commit}, obj) {
      let resp = await goodsCategory(obj);
      commit('GOODS_CATEGORY', resp);
    },
    async plant({commit}, obj) {
      let resp = await plant(obj);
      commit('PLANT', resp);
    },
    //查询详情
    async collectionDetails({commit}, obj){
      let result = await collectionDetails(obj);
      commit('COLLECTION_DETAILS', result);
    },

    async exportData({commit}, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATA', resp);
    },
    //确认可付款
    async submit({commit}, obj){
      let result = await confirmPayable(obj);
      commit('SUBMIT', result);
    },
  }
}
export default collectionLandDeductionState



// WEBPACK FOOTER //
// ./src/page/bd/run/collectionLandDeductionState/store/collectionLandDeductionState.store.js